import MobileNav from '../components/MobileNav';
import React, { useState } from 'react';
import logo from '../assets/images/wordb_logo.svg'
import Feedback from '../components/Feedback';
import Query from '../components/Query';
import Footer from '../components/Footer';
import { Link } from "react-router-dom";

const NotFound = () => {
      const [isFeedbackOpen, setFeedbackOpen] = useState(false);
      const [isQueryOpen, setQueryOpen] = useState(false);
      const toggleFeedback = () => setFeedbackOpen(open => !open);
      const toggleQuery = () => setQueryOpen(open => !open);


  return (
    <>
      <section className='error-page info'>


        {isFeedbackOpen && <Feedback onClose={toggleFeedback} />}
        {isQueryOpen && <Query onClose={toggleQuery} />}

        <MobileNav />




        <div className="info-container">

          <div className="logo-div">
            <img src={logo} alt="" />
          </div>

          <p className="info-h2">404 - Page Not Found</p>
          <p className="txt">
            The page you’re looking for doesn’t exist or the URL might be incorrect.  Please check the URL and try again.
          </p>

          <div className="to-home-cta">
            <Link
              to="/home"
              className="home-link"
            >
              Go to Homepage
            </Link>
          </div>
          <div className="to-home-cta">
            <Link
              to="/leaderboard"
              className="home-link"
            >
              Go to Leaderboard
            </Link>
          </div>


        </div>
        
      <Footer onOpenFeedback={toggleFeedback} onOpenQuery={toggleQuery}/>
      </section>

    </>
  )
}

export default NotFound